export interface ITheme {
  font: string;
  primaryColor: string;
  secondaryColor: string;
  backgroundColor: string;
}
export const Theme: ITheme = {
  font: "",
  primaryColor: "",
  secondaryColor: "",
  backgroundColor: "",
};
